export default {  
    SET_PROGRESSANALYSIS: (state, payload) => state.progressAnalysis = payload,
  }